import React, { useEffect, useState } from 'react';
import { adminService } from '../../services/api';

const EMPTY = { name: '', price_monthly: '', max_machines: 0, features: '', sort_order: 0, is_active: true };

export default function SaPlanos() {
  const [plans, setPlans] = useState([]);
  const [modal, setModal] = useState(null);   // {plan?}
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);

  const load = async () => { const r = await adminService.getPlans(); setPlans(r.data); };
  useEffect(() => { load(); }, []);

  const featuresArr = (f) => {
    if (Array.isArray(f)) return f;
    try { return JSON.parse(f) || []; } catch { return []; }
  };

  const openNew = () => { setForm(EMPTY); setModal({}); };
  const openEdit = (p) => {
    setForm({ name: p.name, price_monthly: p.price_monthly, max_machines: p.max_machines, features: featuresArr(p.features).join(', '), sort_order: p.sort_order, is_active: !!p.is_active });
    setModal({ plan: p });
  };

  const handleSave = async () => {
    if (!form.name) { alert('Nome é obrigatório'); return; }
    setLoading(true);
    const payload = {
      name: form.name, price_monthly: parseFloat(form.price_monthly) || 0,
      max_machines: parseInt(form.max_machines) || 0,
      features: form.features.split(',').map(s => s.trim()).filter(Boolean),
      sort_order: parseInt(form.sort_order) || 0, is_active: form.is_active ? 1 : 0,
    };
    try {
      if (modal.plan) await adminService.updatePlan(modal.plan.id, payload);
      else await adminService.createPlan(payload);
      setModal(null); load();
    } catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Planos</h1>
          <p style={styles.sub}>Planos que você vende para as lan houses</p>
        </div>
        <button style={styles.btnPrimary} onClick={openNew}>+ Plano</button>
      </div>

      <div style={styles.grid}>
        {plans.map(p => (
          <div key={p.id} style={{ ...styles.card, opacity: p.is_active ? 1 : 0.5 }}>
            <div style={styles.name}>{p.name}</div>
            <div style={styles.price}>R$ {Number(p.price_monthly).toFixed(2)}<span style={styles.per}>/mês</span></div>
            <div style={styles.machines}>{p.max_machines > 0 ? `até ${p.max_machines} máquinas` : 'máquinas ilimitadas'}</div>
            <ul style={styles.features}>
              {featuresArr(p.features).map((f, i) => <li key={i} style={styles.feat}>✓ {f}</li>)}
            </ul>
            <button style={styles.btnGhost} onClick={() => openEdit(p)}>Editar</button>
          </div>
        ))}
      </div>

      {modal && (
        <div style={styles.overlay}><div style={styles.modal}>
          <h2 style={styles.modalTitle}>{modal.plan ? 'Editar Plano' : 'Novo Plano'}</h2>
          <Field label="Nome *"><input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></Field>
          <div style={{ display: 'flex', gap: 12 }}>
            <Field label="Preço mensal (R$)" flex><input type="number" step="0.01" style={styles.input} value={form.price_monthly} onChange={e => setForm({ ...form, price_monthly: e.target.value })} /></Field>
            <Field label="Máx. máquinas (0=ilimitado)" flex><input type="number" style={styles.input} value={form.max_machines} onChange={e => setForm({ ...form, max_machines: e.target.value })} /></Field>
          </div>
          <Field label="Recursos (separados por vírgula)">
            <input style={styles.input} value={form.features} onChange={e => setForm({ ...form, features: e.target.value })} placeholder="Mapa da arena, Caixa, Lanchonete" />
          </Field>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <Field label="Ordem" flex><input type="number" style={styles.input} value={form.sort_order} onChange={e => setForm({ ...form, sort_order: e.target.value })} /></Field>
            <label style={{ ...styles.check, flex: 1, marginTop: 20 }}>
              <input type="checkbox" checked={form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked })} /> Ativo
            </label>
          </div>
          <div style={styles.modalActions}>
            <button style={styles.btnGhostBtn} onClick={() => setModal(null)}>Cancelar</button>
            <button style={styles.btnPrimary} onClick={handleSave} disabled={loading}>{loading ? '...' : 'Salvar'}</button>
          </div>
        </div></div>
      )}
    </div>
  );
}

function Field({ label, children, flex }) {
  return <div style={{ marginBottom: 14, ...(flex ? { flex: 1 } : {}) }}><label style={styles.label}>{label}</label>{children}</div>;
}

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 20 },
  title: { color: '#fff', fontSize: 24, fontWeight: 700, margin: 0 },
  sub: { color: '#6b7280', fontSize: 14, margin: '4px 0 0' },
  btnPrimary: { padding: '10px 18px', background: 'var(--accent)', color: '#0a0a0f', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 16 },
  card: { background: '#14141f', border: '1px solid #262636', borderRadius: 14, padding: 22, display: 'flex', flexDirection: 'column', gap: 8 },
  name: { color: '#bef264', fontWeight: 700, fontSize: 18 },
  price: { color: '#fff', fontSize: 30, fontWeight: 800 },
  per: { color: '#6b7280', fontSize: 14, fontWeight: 500 },
  machines: { color: '#9ca3af', fontSize: 13 },
  features: { listStyle: 'none', margin: '10px 0', padding: 0, display: 'flex', flexDirection: 'column', gap: 6 },
  feat: { color: '#9ca3af', fontSize: 13 },
  btnGhost: { padding: '9px 12px', background: 'transparent', border: '1px solid #374151', borderRadius: 8, color: '#bef264', cursor: 'pointer', fontSize: 13, fontWeight: 600, marginTop: 6 },
  btnGhostBtn: { padding: '10px 18px', background: 'transparent', border: '1px solid #374151', borderRadius: 8, color: '#9ca3af', cursor: 'pointer', fontSize: 14 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#14141f', border: '1px solid #262636', borderRadius: 16, padding: 28, width: 460, maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto' },
  modalTitle: { color: '#fff', fontSize: 20, fontWeight: 700, margin: '0 0 20px' },
  label: { display: 'block', color: '#9ca3af', fontSize: 13, fontWeight: 500, marginBottom: 6 },
  input: { width: '100%', padding: '10px 12px', background: '#1c1c2b', border: '1px solid #34344e', borderRadius: 8, color: '#fff', fontSize: 14, boxSizing: 'border-box' },
  check: { display: 'flex', alignItems: 'center', gap: 8, color: '#e5e7eb', fontSize: 14, cursor: 'pointer' },
  modalActions: { display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 20 },
};
